module.exports = __webpack_public_path__ + "static/media/wheel-pointer-dark@2x.802f7553.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_120/imgs/wheel-pointer-dark@2x.png
// module id = 1118
// module chunks = 0